export default __webpack_public_path__ + "static/media/spinner.ec84aa7f.svg";